export interface BlockShape {
  id: string;
  name: string;
  matrix: boolean[][];
  color?: string; // Optional color property
  isSquare?: boolean; // Flag for cube-shaped blocks
}

// Define map of element types to colors
export const ELEMENT_COLORS: {[key: string]: string} = {
  'Tree': '#4CAF50',        // Green
  'Bridge': '#A5744A',      // Light brown
  'Basket': '#FDD835',      // Yellow
  'River': '#64B5F6',       // Light blue
  'Road': '#9E9E9E',        // Grey
  "House": '#F8BBD0'  // Light pink
};

// Default color for shapes
export const DEFAULT_COLOR = '#FF0000'; // Red

// Predefined shapes for the drawing app - Diverse interesting shapes
export const PREDEFINED_SHAPES: BlockShape[] = [
  // Single Pixel Block
  {
    id: 'single-pixel',
    name: 'Single Block',
    matrix: [
      [true]
    ],
    isSquare: true
  },
  
  // Classic Tetris I-Block
  {
    id: 'i-tetromino',
    name: 'I Block',
    matrix: [
      [true, true, true, true]
    ],
    isSquare: true
  },
  
  // Long Rectangle Block
  {
    id: 'long-rect',
    name: 'Rectangle Block',
    matrix: [
      [true, true, true],
      [true, true, true]
    ],
    isSquare: true
  },
  
  // Classic Tetris L-Block
  {
    id: 'l-tetromino',
    name: 'L Block',
    matrix: [
      [true, false],
      [true, false],
      [true, true]
    ],
    isSquare: true
  },
  
  // Classic Tetris T-Block
  {
    id: 't-tetromino',
    name: 'T Block',
    matrix: [
      [true, true, true],
      [false, true, false]
    ],
    isSquare: true
  },
  
  // Stair Block
  {
    id: 'stair-shape',
    name: 'Stair Block',
    matrix: [
      [true, false, false],
      [true, true, false],
      [false, true, true]
    ],
    isSquare: true
  }
];

// Function to get a shape by ID
export const getShapeById = (id: string): BlockShape | undefined => {
  return PREDEFINED_SHAPES.find(shape => shape.id === id);
}; 